
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'VProtocolName',
  props: {
    text: {
      type: String,
      required: false,
    },
    color: {
      type: String,
      required: false,
      default: 'dark',
    },
  },
});
